/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React, { useState } from "react";
import withJobBoardContext from "../../context";
import CountryFilter from "./CountryFilter";
import CreativeFieldFilter from "./CreativeFieldFilter";
import OccasionFilter from "./OccasionFilter";
import useMobile from "../../../../hooks/useMobile";
import Modal from "../../../ui/Modal";

const sortByLabel = (a, b) => {
  if (a.label < b.label) {
    return -1;
  }
  if (a.label > b.label) {
    return 1;
  }
  return 0;
};

const Filters = ({ context }) => {
  const {
    selectedCountries,
    setSelectedCountries,
    countries,
    creativeFields,
    selectedCreativeFields,
    setSelectedCreativeFields,
    occasions,
    selectedOccasions,
    setSelectedOccasions,
  } = context;

  const isMobile = useMobile();
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const countryOptions = countries.map((country) => ({
    label: I18n.t(`country.${country}`),
    value: country,
  })).sort(sortByLabel);

  const creativeFieldOptions = creativeFields.sort((a, b) => {
    if (a === "others") return 1;
    if (b === "others") return -1;
    return 0;
  }).map((creativeField) => ({
    label: I18n.t(`categories.${creativeField}`),
    value: creativeField,
  }));

  const occasionOptions = occasions.sort((a, b) => {
    if (a === "other") return 1;
    if (b === "other") return -1;
    return 0;
  }).map((occasion) => ({
    label: I18n.t(`kinds_of_moment.${occasion}`),
    value: occasion,
  }));

  const handleFilterOpen = () => {
    setIsFilterModalOpen(true);
  };

  const handleFilterClose = () => {
    setIsFilterModalOpen(false);
  };

  if (isMobile) {
    return (
      <>
        <button type="button" onClick={handleFilterOpen} className="b-toolbar__mobile-filters-button">
          {I18n.t("job_board_filters.generic.filters")}
        </button>
        <Modal isOpen={isFilterModalOpen} onClose={handleFilterClose}>
          <div className="b-toolbar__mobile-filters">
            <h3>{I18n.t("job_board_filters.generic.filters")}</h3>
            <div className="b-toolbar__mobile-filters-container">
              <CountryFilter
                options={countryOptions}
                selectedCountries={selectedCountries}
                setSelectedCountries={setSelectedCountries}
              />
              <CreativeFieldFilter
                options={creativeFieldOptions}
                selectedCreativeFields={selectedCreativeFields}
                setSelectedCreativeFields={setSelectedCreativeFields}
              />
              <OccasionFilter
                options={occasionOptions}
                selectedOccasions={selectedOccasions}
                setSelectedOccasions={setSelectedOccasions}
              />
            </div>
            <button type="button" onClick={handleFilterClose} className="b-button b-button--alternative">
              {I18n.t("job_board_filters.mobile_modal.see_results")}
            </button>
          </div>
        </Modal>
      </>
    );
  }

  return (
    <div className="b-toolbar__filter">
      <CountryFilter
        options={countryOptions}
        selectedCountries={selectedCountries}
        setSelectedCountries={setSelectedCountries}
      />
      <CreativeFieldFilter
        options={creativeFieldOptions}
        selectedCreativeFields={selectedCreativeFields}
        setSelectedCreativeFields={setSelectedCreativeFields}
      />
      <OccasionFilter
        options={occasionOptions}
        selectedOccasions={selectedOccasions}
        setSelectedOccasions={setSelectedOccasions}
      />
    </div>
  );
};

export default withJobBoardContext(Filters);
